import { render, staticRenderFns } from "./CountCorrectTable.vue?vue&type=template&id=85bcb958&scoped=true"
import script from "./CountCorrectTable.vue?vue&type=script&lang=js"
export * from "./CountCorrectTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bcb958",
  null
  
)

export default component.exports